import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function EnglishRouteWrapper() {
  const { i18n } = useTranslation();

  useEffect(() => {
    if (i18n.resolvedLanguage !== 'en') {
      i18n.changeLanguage('en');
    }
  }, [i18n]);

  return <Outlet />;
}
